export const BRITISH_CURRICULUM_LABEL = "British Curriculum";
export const IB_CURRICULUM_LABEL = "IB Curriculum";

export function isIbCurriculumLabel(label: string | undefined | null) {
  if (!label) return false;
  return label.trim().toLowerCase() === IB_CURRICULUM_LABEL.toLowerCase();
}

export function isBritishCurriculumLabel(label: string | undefined | null) {
  if (!label) return false;
  return label.trim().toLowerCase() === BRITISH_CURRICULUM_LABEL.toLowerCase();
}
